var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgOpenArrowCircle = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#081319}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 21.79-7.39-6.33.78-.92L17 20.21l6.61-5.67.78.92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1a16 16 0 1 0 16 16A16 16 0 0 0 17 1m0 31a15 15 0 1 1 15-15 15 15 0 0 1-15 15"
  })));
};
const Memo = /*#__PURE__*/memo(SvgOpenArrowCircle);
export default Memo;